import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../guards/services/auth.service';
import { IdentityService } from '../api/services';
import { DtoUserLogin } from '../api/models';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  passwordRegx: RegExp = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;
  err_message = '';
  login_error = false;

  frmLogin = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  constructor(
    private router: Router,
    private ar: ActivatedRoute,
    private auth: AuthService,
    private identityService: IdentityService
    ) { }

  ngOnInit() {

  }

  login() {
    const body: DtoUserLogin = this.frmLogin.value as any;
    this.identityService.identityControllerLoginPassport({body}).subscribe({
      next: async (res) => {
        const token = res.data.access_token;
        await this.auth.storeUser(token);
        if(this.auth.getUser().role.id === 1){
          this.router.navigateByUrl('');
        }else{
          this.login_error = true;
          this.err_message = 'Sembra che tu non sia autorizzato ad effettuare il login.'
        }
      },
      error: (res) => {
        this.login_error = true;
        this.err_message = 'Controlla che la password e la mail siano corrette.'
      }
    })
  }

}
